import { type ListingPriceRating, type R2SPlacement } from '@kijiji/generated/graphql-types'

type BuildBaseTrackingLabelParams = {
  categoryId: number
  isGuestMessageEnabled: boolean
  isUserAuthenticated: boolean
  placement?: R2SPlacement | null
  priceRate?: ListingPriceRating
}

export const getR2SBaseTrackingLabel = ({
  categoryId,
  isGuestMessageEnabled,
  isUserAuthenticated,
  placement,
  priceRate,
}: BuildBaseTrackingLabelParams) => {
  const guestMessageTrackingLabel = `guest_msg=${isGuestMessageEnabled && !isUserAuthenticated}`
  let trackingLabel = `categoryid=${categoryId};${guestMessageTrackingLabel};`

  if (placement) {
    trackingLabel += `location=${placement};`
  }

  if (priceRate) {
    trackingLabel += `price_badge=${priceRate.toLowerCase()};`
  }

  return trackingLabel
}
